import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import PageBanner from "../components/PageBanner";
import {
  GALLERY_ITEMS,
  GALLERY_CATEGORIES,
} from "../constants/galleryPageData";
import "./EventGallery.css";

const categoryLabel = (cat) =>
  cat === "Production" ? "Process & production" : cat;

const EventGallery = () => {
  const [filter, setFilter] = useState("All");

  const filtered = useMemo(() => {
    if (filter === "All") return GALLERY_ITEMS;
    return GALLERY_ITEMS.filter((item) => item.category === filter);
  }, [filter]);

  return (
    <div className="event-gallery-page">
      <PageBanner
        title="Gallery"
        subtitle="A curated look at our events, planning craft, and production standards"
      />

      <section className="section event-gallery-section">
        <div className="section-container">
          <div className="section-header event-gallery-intro">
            <h2 className="section-title">Moments & milestones</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              From corporate showcases to weddings and public experiences—each
              project reflects our focus on clarity, creativity, and flawless
              execution.
            </p>
          </div>

          <div
            className="event-gallery-filters"
            role="group"
            aria-label="Filter gallery by category"
          >
            {GALLERY_CATEGORIES.map((cat) => (
              <button
                key={cat}
                type="button"
                aria-pressed={filter === cat}
                className={`event-gallery-filter${filter === cat ? " is-active" : ""}`}
                onClick={() => setFilter(cat)}
              >
                {categoryLabel(cat)}
              </button>
            ))}
          </div>

          <ul className="event-gallery-grid">
            {filtered.map((item) => (
              <li key={item.id} className="event-gallery-item">
                <figure className="event-gallery-card">
                  <div className="event-gallery-img-wrap">
                    <img
                      src={item.src}
                      alt={`${item.title} — event photography and planning in Ahmedabad, Gujarat`}
                      className="event-gallery-img"
                      loading="lazy"
                      decoding="async"
                    />
                    <figcaption className="event-gallery-caption">
                      <span className="event-gallery-category">
                        {categoryLabel(item.category)}
                      </span>
                      <span className="event-gallery-title">{item.title}</span>
                    </figcaption>
                  </div>
                </figure>
              </li>
            ))}
          </ul>

          {filtered.length === 0 && (
            <p className="event-gallery-empty">No items in this category.</p>
          )}

          <div className="event-gallery-cta">
            <h3 className="event-gallery-cta-title">Want your event featured here?</h3>
            <p className="event-gallery-cta-text">
              Tell us about your date, scale, and vision—we&apos;ll shape a plan
              that fits your brand and budget.
            </p>
            <Link to="/contact" className="event-gallery-cta-btn">
              Start a conversation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EventGallery;
